import { render, staticRenderFns } from "./styj.vue?vue&type=template&id=72cf0e0f&scoped=true"
import script from "./styj.vue?vue&type=script&lang=js"
export * from "./styj.vue?vue&type=script&lang=js"
import style0 from "./styj.vue?vue&type=style&index=0&id=72cf0e0f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cf0e0f",
  null
  
)

export default component.exports